import { Loader, DebounceInputBox } from 'components'
import React, { useEffect, useRef, useState } from 'react'
import './videos.css'
import {
   AscSortIcon,
   DateIcon,
   DescSortIcon,
   DownArrow,
   FilterClearIcon,
   ShortIcon,
   UpArrowIcon
} from 'assets'
import VideoList from './components/VideoList'
import YoutubeShort from './Shorts'
import { useDispatch, useSelector } from 'react-redux'
import {
   clearAllSelections,
   getAllVideoListAction,
   onResetVideoCount,
   setAllVideoDataAction,
   setBatchAnalysisStatus,
   setPageNumberAction,
   toggleVideoList
} from 'store/action/videoReducer'
import FetchNewVideo from './components/FetchNewVideo'
import { useOutsideClick } from 'Hooks'
import BatchAnalysisModal from './components/BatchAnalysisModal'
import axiosInstance from 'utils/axiosConfig'
import { toastError, toastSuccess } from 'utils/toastify'
import { errorMessage, videStatusConst } from 'constant/const'

const BatchConstOpt = [
   {
      label: 'Select Videos',
      value: 1
   },
   {
      label: 'Status',
      value: 2
   }
]

function Videos() {
   const settingData = useSelector((state) => state.settings)
   const { channelDetails, selectedChannelID, channelList } = settingData
   const videoReduxData = useSelector((state) => state.videoRedux)
   const {
      loading,
      totalVideoCount,
      isNextVideoPage,
      isFetchVideo,
      selectedVideoIds,
      isBatchAnalysisStatus,
      isCallListAfterNotification,
      pageNumber,
      allVideoData
   } = videoReduxData

   const [searchName, setSearchName] = useState('')
   const [page, setPage] = useState(1)
   const [isOpenNewVideoModal, setIsOpenNewVideoModal] = useState(false)
   const [sortOpenFilter, setSortOpenFilter] = useState(false)
   const [sortType, setSortType] = useState({ label: 'All', or_type: '' })
   const [isEmpty, setIsEmpty] = useState(false)
   const [showBatchAnalysisModal, setShowBatchAnalysisModal] = useState(false)
   const [loadingAnalysis, setLoadingAnalysis] = useState(false)
   const [openBatch, setOpenBatch] = useState(false)
   const batchRef = useOutsideClick(() => setOpenBatch(false))
   const [selectedBatchType, setSelectedBatchType] = useState(null)

   const onCloseNewVideoModal = () => setIsOpenNewVideoModal(false)
   const onCloseBatchAnalysisModal = () => setShowBatchAnalysisModal(false)

   const [toggleName, setToggleName] = useState('Video')
   const dispatch = useDispatch()

   useEffect(() => {
      if (pageNumber) {
         setPage(pageNumber)
      }

      return () => {}
   }, [pageNumber])

   const getAllVideoList = (page_no, search_name, sort) => {
      dispatch(
         getAllVideoListAction({
            channel_id: selectedChannelID,
            type: toggleName.toUpperCase(),
            search: search_name || '',
            page: page_no || pageNumber || 1,
            sort_by: sort !== 'All' ? sort : ''
         })
      )
      dispatch(setPageNumberAction(page_no || 1))
   }

   // useEffect(() => {
   //    if (isCallListAfterNotification) {
   //       setIsEmpty(true)
   //       dispatch(toggleVideoList())
   //       getAllVideoList(1, '', '')
   //       setPage(1)
   //    }
   //    return () => {}
   // }, [isCallListAfterNotification])

   useEffect(() => {
      if (selectedChannelID && allVideoData?.length === 0) {
         getAllVideoList(pageNumber || 1, '', '')
      }
      return () => {
         // dispatch(onResetVideoCount())
      }
   }, [toggleName, selectedChannelID])

   const OnChangeToggle = (name) => {
      setToggleName(name)
      setSearchName('')
      dispatch(onResetVideoCount())
      // dispatch(setAllVideoDataAction([]))
      dispatch(setPageNumberAction(1))
      setPage(1)
   }

   const onSearchName = (e) => {
      const v_name = e
      setSearchName(v_name)
      // dispatch(setAllVideoDataAction([]))
      dispatch(setPageNumberAction(1))
      getAllVideoList(1, e, sortType.label)
      setIsEmpty(true)
   }

   const onLoadMoreData = () => {
      setPage(1 + page)
      getAllVideoList(1 + page, searchName, sortType.label)
   }

   useEffect(() => {
      if (isFetchVideo) {
         getAllVideoList(1, searchName, sortType.label)
         dispatch(onResetVideoCount())
         setPage(1)
         dispatch(setAllVideoDataAction([]))
         dispatch(setPageNumberAction(1))
      }
   }, [isFetchVideo])

   const onChangeSortType = (type, o_type) => {
      setSortType({ label: type, or_type: o_type })
      getAllVideoList(page, searchName, type)
      setSortOpenFilter(false)
      setIsEmpty(true)
      dispatch(setAllVideoDataAction([]))
      dispatch(setPageNumberAction(1))
   }

   const onRestEmpty = () => setIsEmpty(false)

   const clearFilter = () => {
      setSortType({ label: 'All', or_type: '' })
      getAllVideoList(1, '', '')
      setSearchName('')
      setIsEmpty(true)
      dispatch(setAllVideoDataAction([]))
      dispatch(setPageNumberAction(1))
   }

   const handleBatchVideoAnalysis = async () => {
      if (!selectedChannelID || selectedVideoIds.length === 0) return

      try {
         setLoadingAnalysis(true)
         const videoIdsParam = selectedVideoIds.join(',')
         const response = await axiosInstance.get('/yt/batch_video_analysis', {
            params: {
               channel_id: selectedChannelID,
               video_ids: videoIdsParam
            }
         })
         console.log('batch_video_analysis====', response?.data?.data)
         // update allVideoData
         let video_id_list = response?.data?.data?.video_ids || []

         if (Array.isArray(allVideoData) && allVideoData.length > 0 && video_id_list.length > 0) {
            const result = allVideoData.map((video) =>
               video_id_list.includes(video.video_id)
                  ? {
                       ...video,
                       status: videStatusConst.processing
                    }
                  : video
            )

            dispatch(setAllVideoDataAction(result))
         }
         toastSuccess(response?.data?.message)
      } catch (error) {
         toastError(errorMessage)
         console.error('Error during batch analysis:', error)
      } finally {
         setLoadingAnalysis(false)
         dispatch(clearAllSelections())
         dispatch(setBatchAnalysisStatus(false))
      }
   }

   useEffect(() => {
      return () => {
         dispatch(clearAllSelections())
         dispatch(setBatchAnalysisStatus(false))
      }
   }, [])

   return (
      <div className="video-new-layout-wrap">
         {loading && <Loader />}
         <div className="video-filter-section">
            <div className="card z-2">
               <div className="title-section">
                  <div className="d-flex align-items-baseline justify-content-center gap-2 flex-wrap">
                     <div>
                        <h3 className="at-text-dark">
                           {channelDetails?.channel_name ||
                              channelList?.find((c) => c?.channel_id === selectedChannelID)
                                 ?.channel_name ||
                              ''}
                        </h3>
                        <span>{totalVideoCount} ITEMS</span>
                     </div>
                     {/* <div className="channel-btn" onClick={() => setShowBatchAnalysisModal(true)}>
                     <span>Batch Analysis Status</span>
                  </div> */}
                  </div>

                  <div className="manu-list-section">
                     <div
                        className={`manu-name-section ${toggleName === 'Video' ? 'active' : ''}`}
                        onClick={() => OnChangeToggle('Video')}>
                        Videos
                     </div>
                     <div
                        className={`manu-name-section ${toggleName === 'Shorts' ? 'active' : ''}`}
                        onClick={() => OnChangeToggle('Shorts')}>
                        Shorts
                     </div>
                  </div>
               </div>

               <div className="filter-section mt-3">
                  <DebounceInputBox
                     placeholder={'Search'}
                     value={searchName}
                     onSearch={(e) => onSearchName(e)}
                  />
                  <div className="filter-wrap flex-wrap row-gap-1">
                     {selectedVideoIds?.length > 0 ? (
                        <>
                           <div className="channel-btn" onClick={handleBatchVideoAnalysis}>
                              {loadingAnalysis ? (
                                 <span>
                                    <span className="loader-btn"></span> Saving...
                                 </span>
                              ) : (
                                 <span>Start Batch Analysis ({selectedVideoIds.length})</span>
                              )}
                           </div>
                        </>
                     ) : null}
                     {isBatchAnalysisStatus && (
                        <div
                           className="channel-btn"
                           onClick={() => {
                              dispatch(clearAllSelections())
                              dispatch(setBatchAnalysisStatus(false))
                           }}>
                           <span>Reset</span>
                        </div>
                     )}

                     <div className="comment-filter-section">
                        <div className="at-dropdown-filer-wrap" ref={batchRef}>
                           <div
                              className="at-dropdown-filer"
                              onClick={() => {
                                 setOpenBatch(!openBatch)
                              }}>
                              <span className="text-capitalize">Batch Analysis</span>
                              {openBatch ? <UpArrowIcon /> : <DownArrow />}
                           </div>
                           {openBatch && (
                              <ul className="at-list-opt">
                                 {BatchConstOpt &&
                                    BatchConstOpt?.map((item, i) => {
                                       return (
                                          <li
                                             onClick={() => {
                                                if (item.value === 1) {
                                                   if (selectedVideoIds?.length === 0) {
                                                      dispatch(
                                                         setBatchAnalysisStatus(
                                                            !isBatchAnalysisStatus
                                                         )
                                                      )
                                                   }
                                                }
                                                if (item.value === 2) {
                                                   setShowBatchAnalysisModal(true)
                                                }
                                                setSelectedBatchType(item.value)
                                                setOpenBatch(false)
                                             }}>
                                             <div className="at-list-wrap" key={i}>
                                                {/* {item.value === 1 && selectedVideoIds?.length > 0 ? (
                                                <div
                                                   className=""
                                                   onClick={handleBatchVideoAnalysis}>
                                                   {loadingAnalysis ? (
                                                      <span>
                                                         <span className="loader-btn"></span>{' '}
                                                         Saving...
                                                      </span>
                                                   ) : (
                                                      <span>
                                                         Save Analysis ({selectedVideoIds.length})
                                                      </span>
                                                   )}
                                                </div>
                                             ) : (
                                                <span className="at-opt-name">{item?.label}</span>
                                             )} */}
                                                <span className="at-opt-name">{item?.label}</span>
                                             </div>
                                          </li>
                                       )
                                    })}
                              </ul>
                           )}
                        </div>
                     </div>

                     <div
                        className="owner-logo-section add-border videos-filter-icon"
                        title="Fetch New Video"
                        onClick={() => setIsOpenNewVideoModal(true)}>
                        <DateIcon />
                     </div>

                     <VideoListSortFilter
                        setSortOpenFilter={setSortOpenFilter}
                        sortOpenFilter={sortOpenFilter}
                        onChangeSortType={onChangeSortType}
                        sortType={sortType}
                     />

                     {(sortType.label !== 'All' || searchName) && (
                        <div
                           className="owner-logo-section add-border videos-filter-icon"
                           onClick={clearFilter}
                           title="Clear Filter">
                           <FilterClearIcon />
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </div>

         <div className="video-wrap mt-3">
            {toggleName === 'Video' ? (
               <VideoList onRestEmpty={onRestEmpty} isEmpty={isEmpty} />
            ) : (
               <YoutubeShort onRestEmpty={onRestEmpty} isEmpty={isEmpty} />
            )}
         </div>

         <div className="load-more mt-4">
            <div
               className="atenya-ai-btn"
               onClick={() => (isNextVideoPage ? onLoadMoreData() : setIsOpenNewVideoModal(true))}>
               <span>{isNextVideoPage ? 'Load More' : 'Fetch More'}</span>
            </div>
         </div>

         {isOpenNewVideoModal && (
            <FetchNewVideo
               isOpenNewVideoModal={isOpenNewVideoModal}
               onClose={onCloseNewVideoModal}
               type={toggleName}
            />
         )}

         {showBatchAnalysisModal && (
            <BatchAnalysisModal
               isOpenNewVideoModal={showBatchAnalysisModal}
               onClose={onCloseBatchAnalysisModal}
               selectedChannelID={selectedChannelID}
            />
         )}
      </div>
   )
}

export default Videos

const VideoListSortFilter = ({ setSortOpenFilter, sortOpenFilter, onChangeSortType, sortType }) => {
   const sortTypeRef = useOutsideClick(() => setSortOpenFilter(false))

   return (
      <div className="at-dropdown-filer-wrap at-sort" ref={sortTypeRef}>
         <div
            className="owner-logo-section add-border videos-filter-icon"
            onClick={() => setSortOpenFilter(!sortOpenFilter)}
            title="Sort By">
            <ShortIcon />
            {sortType.label !== 'All' && <div className="active-dot"></div>}
         </div>
         {sortOpenFilter && (
            <ul className="at-list-opt">
               <li onClick={() => onChangeSortType('All', '')}>
                  <div className="at-list-wrap">
                     <span className="at-opt-name">All</span>
                     <span className={`at-opt-pin ${sortType.label === 'All' ? 'active' : ''}`}>
                        <span className="w-dot"></span>
                     </span>
                  </div>
               </li>

               <SortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Sentiment Score'}
                  value={'sentiment_score'}
               />
               <SortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Risk Score'}
                  value={'risk_score'}
               />
               <SortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Published At'}
                  value={'published_at'}
               />
            </ul>
         )}
      </div>
   )
}

const SortItemLi = ({ onChangeSortType, sortType, label, value }) => {
   return (
      <li
         onClick={() => {
            if (sortType.or_type === 'asc') {
               onChangeSortType(value, 'desc')
            } else if (sortType.or_type === 'desc') {
               onChangeSortType(`-${value}`, 'asc')
            } else {
               onChangeSortType(value, 'desc')
            }
         }}>
         <div className="at-list-wrap">
            <span className="at-opt-name">{label}</span>
            <div className="sort-dot-icon">
               {sortType?.label === value || sortType.label === `-${value}` ? (
                  sortType.or_type === 'asc' ? (
                     <DescSortIcon />
                  ) : sortType.or_type === 'desc' ? (
                     <AscSortIcon />
                  ) : (
                     <ShortIcon />
                  )
               ) : (
                  <ShortIcon />
               )}
               <span
                  className={`at-opt-pin ${
                     sortType.label === value || sortType.label === `-${value}` ? 'active' : ''
                  }`}>
                  <span className="w-dot"></span>
               </span>
            </div>
         </div>
      </li>
   )
}
